import ApiService from '@/services/api.service';
import getters from '@/store/global';

const state = {
    mordaLenta: [],
    fund: 0,
    errors: {}
}

getters['getMordaLenta'] = function(state) { return state.mordaLenta }
getters['fetchMordaLentaFund'] = function(state) { return state.fund }

const actions = {
    get(context) {
        return ApiService
            .get('home/morda-lenta/')
            .then((response) => {
                context.commit('SET_MORDA_LENTA', response.data)
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            });
    },
    buy(context, payload) {
        return ApiService
            .post('home/morda-lenta/buy/', payload)
            .then((response) => {
                context.commit('SET_ERROR', {});
            })
            .catch((response) => {
                if(response.status === 400){
                    context.commit('SET_ERROR', response.data);
                }
                throw new Error('Something goes wrong');
            });
    },
    getFund(context) {
        return ApiService
            .get('home/morda-lenta/prize_fund/')
            .then((response) => {
                context.commit('SET_MORDA_LENTA_FUND', response.data)
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            });
    },
    setFund(context, payload) {
        context.commit('SET_MORDA_LENTA_FUND', payload);
    }
}

const mutations = {
    SET_MORDA_LENTA(state, mordaLenta) {
        state.mordaLenta = mordaLenta;
        state.errors = {};
    },
    SET_MORDA_LENTA_FUND(state, fund) {
        state.fund = fund;
    },
    SET_ERROR(state, errors) {
        state.errors = errors;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
